import styled from "styled-components";

export const ContainerCard = styled.div`
  position: relative;
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  width: ${(props) => props.width || "328px"};
  height: ${(props) => props.height || "165px"};
  padding: 0 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;

  @media screen and (min-width: 769px) {
    width: ${(props) => props.width || "386px"};
    height: ${(props) => props.height || "170px"};
  }
`;

export const Title = styled.span`
  font-family: Gilroy;
  color: ${(props) => props.color || "#1F2D3D"};
  font-size: ${(props) => props.fontSize || "11px"};
  line-height: ${(props) => props.lineHeight || "13px"};
  font-weight: ${(props) => props.fontWeight || 700};

  @media screen and (min-width: 769px) {
    font-size: ${(props) => props.fontSize || "14px"};
    line-height: ${(props) => props.lineHeight || "19px"};
  }
`;

export const PhotoPNG = styled.img`
  position: absolute !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 114px;
  height: 145px !important;
`;

export const ImageBadgeCity = styled.img`
  width: 48px;
  height: 39px;
`;

export const FillStateHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FillStateBody = styled.div`
  position: relative;
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  width: ${(props) => props.width || "328px"};
  height: ${(props) => props.height || "165px"};
  padding: 12px 16px;
  border-radius: ${(props) => props.borderRadius || "16px"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  overflow: hidden;

  @media screen and (min-width: 769px) {
    width: ${(props) => props.width || "386px"};
    height: ${(props) => props.height || "160px"};
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.div`
  border-radius: 4px;
  text-align: center;
  background: rgba(31, 45, 61, 0.7);
  width: fit-content;
  padding: 0 4px;
  height: 14px;
  color: #fff;
  font-size: 9px;
  line-height: 16px;
`;

export const TeamWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-top: 8px;
`;

export const Row = styled.div`
  background-color: ${(props) => props.backgroundColor || "#fff"};
  border-bottom: ${(props) => props.borderBottom || "0.5px solid #6a7481"};
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: ${(props) => props.borderRadius || "0px 0px 16px 16px"};
  height: ${(props) => props.height || "auto"};
`;

export const RowContent = styled.div`
  display: flex;
  column-gap: ${(props) => props.colGap || "28px"};
  align-items: center;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelOnGoing = styled.div`
  background-color: #ff100d;
  border-radius: 24px;
  color: white;
  margin-left: 4px;
  margin-right: 12px;
  font-size: 10px;
  font-weight: bold;
  padding: 0px 4px;
`;

export const ContainerCardRule = styled.div`
  position: relative;
  background-image: ${(props) => `url('${props.img}')`};
  background-position: left;
  background-size: cover;
  background-repeat: no-repeat;
  width: ${(props) => props.width || "328px"};
  height: ${(props) => props.height || "165px"};
  padding: 16px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;

  @media screen and (min-width: 769px) {
    width: ${(props) => props.width || "386px"};
    height: ${(props) => props.height || "160px"};
    padding: ${(props) => props.padding || "30px 16px"};
  }
`;

export const Button = styled.button`
  display: flex;
  height: 24px;
  min-height: ${(props) => props.height || "24px"};
  max-height: ${(props) => props.height || "24px"};
  width: ${(props) => props.width || "fit-content"};
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #00bcf1;
  font-size: ${(props) => props.fontSize || "14px"};
  line-height: 19px;
  font-weight: bold;
  color: #00bcf1;
`;

export const ImageTrophy = styled.img`
  width: 61px;
  height: 90px;

  @media screen and (min-width: 769px) {
    width: 68px;
    height: 100px;
  }
`;

export const ImageSupporter = styled.img`
  width: 77px;
  height: 132px;

  // @media screen and (min-width: 769px) {
  //   width: 110px;
  //   height: 189px;
  // }
`;
